<template>
<div id="purchase-search">
  <search-form
    legend="Purchases"
    :pageRef="$parent"
    :searchUrl="searchUrl"
    :labels="labels"
  />
</div>
</template>
<script>
import SearchForm from '@/components/PagedSearchFieldForm'

export default {
  data () {
    return {
      action: undefined,
      labels: [
        {
          lbl: 'Email',
          action: 'email'
        },
        {
          lbl: 'Payment',
          action: 'payments'
        }
      ],
      searchType: 'email'
    }
  },

  props: {
    initialSearchType: {
      type: String,
      default: undefined
    }
  },

  computed: {
    basePath () {
      return this.apiUrl('/purchases', true)
    },

    searchUrl () {
      let subPath = '/search/'

      switch (this.searchType) {
        case 'payments':
          subPath += this.searchType
      }

      return [
        this.basePath,
        subPath
      ].join('')
    }
  },

  components: {
    'search-form': SearchForm
  },

  created () {
    this.$on('searchQueryUpdated', this.onSearchQueryUpdated)
  },

  methods: {
    onSearchQueryUpdated (query) {
      this.searchType = query.queryType
      this.$parent.$emit('searchQueryUpdated', query)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PurchaseSearch.vue